import React, { useState } from "react";
import RouterScreen from "../RouterScreen";
import { withOrientationChange } from "react-device-detect";
import RotateModal from "../../components/RotateModal";

// const GlobalStyles = createGlobalStyle`
//   body {
//     @import url(${fontUrls1});
//     font-family: 'UberMove-Light';
//   }
// `
const App = (props) => {
  const { isPortrait, isLandscape } = props;
  console.log("props: ", props);
  const [openPopup, setOpenPopup] = useState(true);
  return (
    <>
      {/* <GlobalStyles/> */}
      <RouterScreen />
      {/* <RotateModal isOpen={isPortrait || isLandscape} /> */}
      <RotateModal
        isOpen={isPortrait}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      />
    </>
  );
};

export default withOrientationChange(App);
